export default __webpack_public_path__ + "static/media/boxtype10.aac6d808.JPG";